<form [formGroup]="roleForm" (ngSubmit)="saveRole(inProgress)">
    <div class=" modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i class="ri-user-settings-line me-1 font-20 text-primary"></i>{{roleForm.value.id?'Update':'Add'}} Role
        </h5>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
            (click)="activeModal.close('Close')"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3 mb-2">
            <div class="col-md-4">
                <label for="name" class="form-label">Role Name <b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-buildings'></i></span>
                    <input type="text" class="form-control ps-1" id="name" placeholder="Enter role name"
                        [ngClass]="{'is-invalid': submitted && r.name.errors}" formControlName="name" ngbAutofocus
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && r.name.errors">
                        <span *ngIf="r.name.errors.required">Please provide a valid Role name.</span>
                        <span *ngIf="r.name.errors.pattern">Only letters are allowed.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="type" class="form-label">Persona<b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-grid-alt'></i></span>
                    <select class="form-select ps-1" formControlName="persona"
                        [ngClass]="{'is-invalid': submitted && r.persona.errors}">
                        <option selected disabled hidden ngValue="">Select a Persona</option>
                        <option *ngFor=" let persona of personas;" [ngValue]="persona">{{persona}}</option>
                    </select>
                    <div class="invalid-feedback" *ngIf="submitted && r.persona.errors">
                        <span *ngIf="r.persona.errors.required">Please select a Persona.</span>
                        <span *ngIf="r.persona.errors.pattern">Only letters are allowed.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-auto">
                <div class="form-check">
                    <input class="form-check-input checkbox" type="checkbox" id="disabled" formControlName="disabled">
                    <label class="form-check-label" for="disabled">Disabled</label>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 ">
            <section class="rcx-table">
                <table
                    class="table table-bordered dt-responsive nowrap datatables no-footer dtr-inline tw-sm-250 tw-md-102">
                    <thead class="table-thead">
                        <tr class="bg-light">
                            <th width="200">Module</th>
                            <th class="w-0">
                                <div class="role-check">
                                    <input type="checkbox" class="form-check-input c-check" id="ordercheck"
                                        [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                                        [checked]="isAllSelected" (change)="checkAll($event,modules)">
                                    <label class="form-check-label mb-0" for="ordercheck">&nbsp;</label>
                                </div>
                            </th>
                            <th>Feature</th>
                            <th width="300" class="text-center">Privilege</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let module of modules | keyvalue; let i=index;">
                            <tr>
                                <td [attr.rowspan]="module.value.length" class="text-center align-middle"
                                    [ngClass]="{'bg-light':i %2==0,'bg-white':i %2!=0}">
                                    {{module.key}}
                                </td>
                                <ng-container *ngIf="module.value[0]">
                                    <td>
                                        <div class="role-check">
                                            <input type="checkbox" class="form-check-input" [id]="'check'+i"
                                                [checked]="module.value[0].selected"
                                                (change)="checkIfAllSelected($event.target.checked,module.value[0])"
                                                [(ngModel)]="module.value[0].selected"
                                                [ngModelOptions]="{standalone: true}">
                                            <label class="form-check-label mb-0" [for]="'check'+i">&nbsp;</label>
                                        </div>
                                    </td>
                                    <td id="ordercheck10">
                                        {{module.value[0].module}}
                                    </td>
                                    <td class="dtr-control d-flex justify-content-around">
                                        <div class="role-check">
                                            <input class="form-check-input" type="radio"
                                                [name]="module.value[0].module" [id]="'r1'+i" value="VIEW"
                                                [checked]="module.value[0].privilege=='VIEW'"
                                                [(ngModel)]="module.value[0].privilege"
                                                [ngModelOptions]="{standalone: true}">
                                            <label class="form-check-label mt-1px ms-1" [for]="'r1'+i">
                                                View
                                            </label>
                                        </div>
                                        <div class="role-check">
                                            <input class="form-check-input" type="radio"
                                                [name]="module.value[0].module" [id]="'r2'+i" value="EDIT"
                                                [checked]="module.value[0].privilege=='EDIT'"
                                                [(ngModel)]="module.value[0].privilege"
                                                [ngModelOptions]="{standalone: true}">
                                            <label class="form-check-label mt-1px ms-1" [for]="'r2'+i">
                                                Edit
                                            </label>
                                        </div>
                                        <div class="role-check">
                                            <input class="form-check-input" type="radio"
                                                [name]="module.value[0].module" [id]="'r3'+i" value="DELETE"
                                                [checked]="module.value[0].privilege=='DELETE'"
                                                [(ngModel)]="module.value[0].privilege"
                                                [ngModelOptions]="{standalone: true}">
                                            <label class="form-check-label mt-1px ms-1" [for]="'r3'+i">
                                                Delete
                                            </label>
                                        </div>
                                    </td>

                                </ng-container>
                            </tr>
                            <ng-container *ngFor="let feature of module.value; let j=index;">
                                <ng-container *ngIf="j!=0">
                                    <tr>
                                        <td class="dtr-control">
                                            <div class="role-check">
                                                <input type="checkbox" class="form-check-input" [id]="'ck'+j+i"
                                                    [checked]="feature.selected" [(ngModel)]="feature.selected"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (change)="checkIfAllSelected($event.target.checked,feature)">
                                                <label class="form-check-label mb-0" [for]="'ck'+j+i">&nbsp;</label>
                                            </div>
                                        </td>
                                        <td>
                                            {{feature.module}}
                                        </td>
                                        <td class="dtr-control d-flex justify-content-around">
                                            <div class="role-check">
                                                <input class="form-check-input" type="radio" [name]="feature.module"
                                                    [id]="'r4'+j+i" value="VIEW" [checked]="feature.privilege=='VIEW'"
                                                    [(ngModel)]="feature.privilege"
                                                    [ngModelOptions]="{standalone: true}">
                                                <label class="form-check-label mt-1px ms-1" [for]="'r4'+j+i">
                                                    View
                                                </label>
                                            </div>
                                            <div class="role-check">
                                                <input class="form-check-input" type="radio" [name]="feature.module"
                                                    [id]="'r5'+j+i" value="EDIT" [checked]="feature.privilege=='EDIT'"
                                                    [(ngModel)]="feature.privilege"
                                                    [ngModelOptions]="{standalone: true}">
                                                <label class="form-check-label mt-1px ms-1" [for]="'r5'+j+i">
                                                    Edit
                                                </label>
                                            </div>
                                            <div class="role-check">
                                                <input class="form-check-input" type="radio" [name]="feature.module"
                                                    [id]="'r6'+j+i" value="DELETE"
                                                    [checked]="feature.privilege=='DELETE'"
                                                    [(ngModel)]="feature.privilege"
                                                    [ngModelOptions]="{standalone: true}">
                                                <label class="form-check-label mt-1px ms-1" [for]="'r6'+j+i">
                                                    Delete
                                                </label>
                                            </div>
                                        </td>

                                    </tr>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table>

            </section>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i
                class="bx bx-x"></i>Close</button>
        <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}">
            <ng-container *ngIf="inProgress?.value=='true'">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{roleForm.value.id?'Updating...':'Saving...'}}
            </ng-container>
            <ng-container *ngIf="inProgress?.value!='true'">
                <i class="bx bx-save"></i>{{roleForm.value.id?'Save Changes':'Save'}}
            </ng-container>
        </button>
    </div>
</form>
